import api from "./axios";
import { getDeviceFingerprint } from "../lib/deviceFingerprint";

export const login = (username, password) =>
  api.post("/api/accounts/login/", { username, password });

// Signup sends X-Device-Fingerprint so the backend's anti-abuse layer can
// log + correlate accounts. The fingerprint is stable per browser+device
// (cached in localStorage); see lib/deviceFingerprint.js.
export const signup = (payload) =>
  api.post("/api/accounts/register/", payload, {
    headers: { "X-Device-Fingerprint": getDeviceFingerprint() },
  });

export const logout = () => api.post("/api/accounts/logout/");

export const me = () => api.get("/api/accounts/me/");

export const verifyEmail = (token) =>
  api.post("/api/accounts/verify-email/", { token });

export const resendVerification = (email) =>
  api.post("/api/accounts/resend-verification/", { email });

export const forgotPassword = (email) =>
  api.post("/api/accounts/forgot-password/", { email });

export const resetPassword = (uidb64, token, new_password) =>
  api.post("/api/accounts/reset-password/", { uidb64, token, new_password });

// Phone OTP — WhatsApp first, SMS as the fallback (or logged to the
// console in dev when no provider is configured on the EC2 box).
// `channel: "sms"` skips WhatsApp: a WhatsApp send to a number with no
// WhatsApp account is accepted by Twilio and only fails minutes later,
// so the server's automatic fallback never fires for that user.
export const requestPhoneOtp = (phone, channel) =>
  api.post("/api/accounts/request-otp/", channel ? { phone, channel } : { phone });

// Verify returns { phone_verification_token } that must be sent to /register/.
export const verifyPhoneOtp = (phone, otp) =>
  api.post("/api/accounts/verify-otp/", { phone, otp });

// Public snapshot of signup feature flags. SPA reads this on Signup mount
// so the OTP step is hidden when REQUIRE_PHONE_OTP_ON_SIGNUP is off server-
// side.
export const fetchSignupConfig = () =>
  api.get("/api/accounts/signup-config/");
